import {isDebug} from "../appConf";
import BridgeHelper, { openInApp } from '../bridge/bridgeHelper'

export const mPrint = (message?: any, ...optionalParams: any[]) => {
    if (openInApp) {
        BridgeHelper.logInfo("[OfficePal] =>", message, ...optionalParams)
    } else {
        isDebug && console.log("[OfficePal] =>", message, ...optionalParams)
    }
}
